import { useState } from "react";
import { heroStats } from "@/mocks/home";

const entryUrl = "https://sufeids.cn";

export default function Hero() {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(entryUrl);
    } catch {
      /* noop */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-20 -left-16 h-64 w-64 rounded-full bg-accent-100/70 blur-3xl"></div>

      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 lg:grid-cols-2 lg:gap-14 lg:py-20">
        {/* 左：文案 + 入口 */}
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-70"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600"></span>
            </span>
            最新发布页实时同步中 · 永久入口在线
          </div>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[2.6rem] md:leading-[1.15]">
            吃瓜地址最新发布页，
            <span className="relative text-primary-600">
              防走丢
              <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 9" fill="none" preserveAspectRatio="none" aria-hidden="true">
                <path d="M2 7C50 2 150 2 198 7" stroke="oklch(var(--accent-500))" strokeWidth="4" strokeLinecap="round" />
              </svg>
            </span>
            的新网址与永久入口
          </h1>

          <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-foreground-600">
            实时同步最新网址与永久入口，防止走丢；提供防屏蔽更新提醒，让你随时都能找到吃瓜地址最新发布页，
            不错过任何新内容。无论主站怎么变，回到这里就能续上。
          </p>

          {/* 当前入口 */}
          <div className="mt-7 flex flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-3.5 sm:flex-row sm:items-center sm:justify-between sm:rounded-full sm:px-4">
            <div className="flex min-w-0 items-center gap-3 px-1 sm:px-2">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-link text-lg"></i>
              </span>
              <div className="min-w-0">
                <p className="text-[11px] text-foreground-500">最新可用入口</p>
                <p className="truncate font-medium text-foreground-950">{entryUrl}</p>
              </div>
            </div>
            <button
              type="button"
              onClick={copy}
              className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className={`${copied ? "ri-check-line" : "ri-file-copy-line"} text-base`}></i>
              {copied ? "已复制" : "复制地址"}
            </button>
          </div>

          {/* 次级行动 + 快捷锚点 */}
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <a
              href="#guide"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-shield-check-line mr-1.5 text-base text-accent-600"></i>
              防走丢指南
            </a>
            <a
              href="#zones"
              className="inline-flex items-center whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800"
            >
              去讨论分区看看
              <i className="ri-arrow-right-line ml-1 text-base"></i>
            </a>
          </div>

          {/* 轻数据 */}
          <div className="mt-8 flex items-center gap-6 border-t border-background-200/80 pt-6 sm:gap-10">
            {heroStats.map((s) => (
              <div key={s.label}>
                <p className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 右：对开图 */}
        <div className="relative lg:pl-4">
          <div className="relative mx-auto aspect-[4/4.4] w-full max-w-md overflow-hidden rounded-3xl border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20warm%20community%20of%20friends%20gathered%20around%20a%20giant%20refreshing%20watermelon%20slice%2C%20casual%20lively%20discussion%20with%20floating%20speech%20bubbles%20and%20small%20leaf%20accents%2C%20soft%20cream%20background%2C%20fresh%20tangerine%20and%20watermelon%20green%20palette%2C%20minimalist%20flat%20vector%20art%2C%20cozy%20community%20feeling%2C%20clean%20composition%2C%20no%20text&width=860&height=900&seq=hero-melon-open&orientation=portrait"
              alt="吃瓜地址社区讨论氛围插画"
              title="吃瓜地址最新发布页"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-background-950/5"></div>
          </div>

          {/* 浮动小卡 */}
          <div className="absolute -left-2 bottom-8 hidden items-center gap-2.5 rounded-xl border border-background-200 bg-background-50 px-3.5 py-2.5 shadow-none sm:flex md:-left-4">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-chat-check-line text-base"></i>
            </span>
            <div>
              <p className="text-xs font-semibold text-foreground-950">防走丢机制已开启</p>
              <p className="text-[11px] text-foreground-500">新网址切换有提醒</p>
            </div>
          </div>

          <div className="absolute -right-1 top-8 hidden items-center gap-2 rounded-xl border border-background-200 bg-background-50 px-3 py-2 shadow-none sm:flex md:-right-3">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-primary-700">
              <i className="ri-time-line text-sm"></i>
            </span>
            <span className="text-xs font-semibold text-foreground-900">今日已同步 · 在线</span>
          </div>
        </div>
      </div>
    </section>
  );
}